import {TrafficDetailsMapApp} from "../Functionality/TrafficDetailsMapApp";
import {CommonMapApp} from "../../../../../components/Leaflet/CommonMapApp";
import ZoneLeaflet from "../../../../../components/ZoneLeaflet";
import NotInformation from "../../../../../components/NotInformation";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const TrafficDetailsMap = ({setDetailsModal, dateRange, setFinesCount, finesCount,setItemSelected, modified}) => {

    const {
        locations,
        searchLocation,
        dispatch,
        t,
        direction,
        handleChange,
        item,
        handleMapMove,
    } = TrafficDetailsMapApp({dateRange,setFinesCount});

    const { companyIcon, marker, handleMarkerHover } = CommonMapApp({
        t,
        locations,
        dispatch,
    });

    return (
        <>
            {finesCount === 0 ?   <NotInformation text={t('user_no_infractions_period')} card={true} />
                : <div className="w-100 h-100 border-radius-8px position-relative overflow-hidden">
                    <ZoneLeaflet
                        setLatitude={(value) => handleChange({ target: { name: "latitude", value } })}
                        setLongitude={(value) => handleChange({ target: { name: "longitude", value } })}
                        latlng={[item?.latitude, item?.longitude]}
                        searchLocation={searchLocation}
                        markersList={marker}
                        disabled={true}
                        iconMarker={companyIcon}
                        onMarkerClick={(marker) => {
                            if(marker?.id){
                                setItemSelected(marker?.id)
                                setDetailsModal(true);
                            }
                        }}
                        onMarkerHover={handleMarkerHover}
                        marginBottom={80}
                        onMapMove={handleMapMove}
                        ifCluster={true}
                    />
                    <div className={"position-absolute bottom-25px left-0"}>
                        <div className="d-flex justify-content-flex-end">
                            <p className="fs-12px ibl-font-w-400 font-color-primary-700 text-break-wrap">{direction}</p>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};
export default TrafficDetailsMap;
